import { render, staticRenderFns } from "./AlarmObject.vue?vue&type=template&id=96f2a94a&scoped=true&"
import script from "./AlarmObject.vue?vue&type=script&lang=js&"
export * from "./AlarmObject.vue?vue&type=script&lang=js&"
import style0 from "./AlarmObject.vue?vue&type=style&index=0&id=96f2a94a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f2a94a",
  null
  
)

export default component.exports